import { countries as availableCountries } from 'utils/enums/countries.enum';

export const mapSettingsToObject = (settings) => {
	const settingsObject = settings.reduce((result, item) => {

		switch (item.dataType) {
			case 'number':
				result[item.name] = Number(item.value);
				break;
			default:
				result[item.name] = item.value;
				break;
		}

		switch (item.name) {
			case 'allowedCountryForPhoneNumbers': {
				const countries = item.value.split(';') || [];
				result[item.name] = availableCountries.reduce((acc, item) => {
					if (countries.includes(item.code)) {
						acc.push(item);
					}
					return acc;
				}, []);
				break;
			}
			case 'country': {
				result[item.name] = availableCountries.find(({ code }) => code === item.value);
				break;
			}
			default:
				break;
		}

		return result;
	}, {});

	return settingsObject;
}